<button class="close icon icon-cross icon-size-16"
        mat-button
        (click)="close()"
        [attr.aria-label]="'Fermer' | transloco">
</button>
<div class="mat-dialog-header">
    <h2>{{ 'Acces produits' | transloco }}</h2>
</div>
<mat-dialog-content>
    <div class="display-products">
        <p class="display-products__desc"
        *ngIf="hasProductsAccess"
           [innerHtml]="'Voici la liste des produits auxquels <strong>$orga$</strong> souhaite vous accorder un acces :' | transloco: {orga: data.organisation }">
        </p>
        <p class="display-products__desc"
        *ngIf="!hasProductsAccess"
           [innerHtml]="'<strong>$orga$</strong> ne vous a pas encore accorde d\'acces a ses produits.' | transloco: {orga: data.organisation }">
        </p>
        <div class="display-products__list"
             *ngFor="let item of servicesList | keyvalue">
            <div class="list-item__service">
                <span class="list-item__icon"
                      [ngClass]="returnProductIcon(item.key)"
                      [style.color]="returnProductTypeColor(item.key)"></span>
                <span class="list-item__infos">
                    <div class="list-item__service-name">
                        {{item.value}}&nbsp;{{getServiceName(item.key)}}
                    </div>
                </span>
            </div>
        </div>
    </div>
</mat-dialog-content>
<div class="mat-dialog-footer">
    <div class="block-buttons clearfix">
        <button mat-flat-button
                (click)="close()"
                [attr.aria-label]="'Fermer' | transloco"
                color="accent">
            {{ 'Fermer' | transloco }}
        </button>
    </div>
</div>
